<template>
    <div id="top_menu" style="margin: 1rem 0;">
        <div class="ui floated right compact menu">
            <div class="item mobile hidden" v-if="is_can_use_scanner"
                :data-tooltip="$t('ui.links.top_menu.scanner') + '（' + $t('ui.general.hot_key')+'：Ctrl + Q）'"
                data-position="bottom center">
                <div class="ui icon button"
                    @click="$bus.$emit('toggle_scanner_modal', 'show')">
                    <i class="barcode large icon"></i>
                </div>
            </div>
            <div class="item" v-else :data-tooltip="$t('ui.general.cannot_use')" data-position="bottom center">
                <div class="ui icon button">
                    <i class="red barcode large icon"></i>
                </div>
            </div>

            <div class="item" :data-tooltip="$t('ui.links.top_menu.language')"  data-position="bottom center">
                <div class="ui icon dropdown top right pointing button" v-dropdown>
                    <i class="globe large icon"></i>
                    <div class="menu">
                        <a class="item" @click="change_i18n('zh-TW')">繁體</a>
                        <a class="item" @click="change_i18n('zh-CN')">简体</a>
                        <a class="item" @click="change_i18n('ja-JP')">日本語</a>
                        <a class="item" @click="change_i18n('ko-KR')">한국어</a>
                        <a class="item" @click="change_i18n('en-US')">English</a>
                        <a class="item" @click="change_i18n('de-DE')">Deutsch</a>
                        <a class="item" @click="change_i18n('es-ES')">Español</a>
                        <a class="item" @click="change_i18n('vi-VN')">Tiếng Việt</a>
                        <a class="item" @click="change_i18n('km-KH')">ភាសាខ្មែរ</a>
                    </div>
                </div>
            </div>

            <div class="item">
                <Notifications :channel_identity="channel_identity"></Notifications>
            </div>

            <div class="item" style="padding: .5em 0 .5em .5em;">
                <div class="ui icon dropdown top right pointing button" v-dropdown>
                    <i class="setting large icon"></i>
                    <div class="menu">
                        <div class="header">
                            {{ current_customer_name }}
                        </div>
                        <a class="item" @click="$parent.show_login_timeout_hint">
                            {{ $t('ui.links.top_menu.overtime_note') }}
                        </a>
                        <a class="item" @click="$parent.logout">
                            {{ $t('ui.links.top_menu.logout') }}
                        </a>
                    </div>
                </div>
            </div>
            <div class="item">
                <SpeedTest></SpeedTest>
            </div>
        </div>


        <!-- <div class="right menu">

            <div class="item pointer mobile hidden"
                v-if="is_can_use_scanner"
                :data-tooltip="$t('ui.general.hot_key')+'： ctrl + Q'"
                :data-position="'bottom center'"
                @click="$bus.$emit('toggle_scanner_modal', 'show')">
                {{ $t('ui.links.top_menu.scanner') }}
            </div>
            <div class="item red active"
                v-else
                :data-tooltip="$t('ui.general.cannot_use')"
                :data-position="'bottom center'">
                {{ $t('ui.links.top_menu.scanner') }}
            </div>

            <div class="ui dropdown item" v-dropdown>
                {{ $t('ui.links.top_menu.language') }}
                <i class="dropdown icon"></i>
                <div class="menu">
                    <a class="item" @click="change_i18n('zh-TW')">繁體</a>
                    <a class="item" @click="change_i18n('zh-CN')">简体</a>
                    <a class="item" @click="change_i18n('en-US')">English</a>
                </div>
            </div>

            <div class="ui dropdown item" v-dropdown>
                <i class="user icon"></i> {{ current_customer_name }} <i class="dropdown icon"></i>
                <div class="menu">
                    <a class="item" @click="$parent.show_login_timeout_hint">
                        {{ $t('ui.links.top_menu.overtime_note') }}
                    </a>
                    <a class="item" @click="$parent.logout">
                        {{ $t('ui.links.top_menu.logout') }}
                    </a>
                </div>
            </div>
        </div> -->
        <div class="clear"></div>

    </div>
</template>

<script>
    import Partitions from './top_menu_partitions.vue'
    import SpeedTest from "@toolbox/speed_test/main.vue"
    import Notifications from "@toolbox/notifications/main.vue"

    export default {
        data() {
            return {
                is_development: (ENV.NODE_ENV == 'development') ? true : false,
            }
        },
        mounted() {
            $(document).ready(() => {
                $(document).delegate('.quick_link_select .menu .item', 'click',(event) => {
                    window.location = $(this).data('url')
                })
            })
        },
        computed: {
            is_can_use_scanner() {
                return this.$store.state.customer.is_can_use_scanner
            },
            current_customer_name() {
                return this.$store.state.customer.customer.company_name
            },
            channel_identity() {
                return this.$store.state.customer.customer.identity
            },
            customer_partitions() {
                return this.$store.state.customer_partitions
            },
        },
        methods: {
            change_i18n(language = "zh-TW") {
                localStorage.setItem("language", language)
                this.$store.state.language = language
            },
            set_current_station() {
                $('.ui.basic.stations.modal')
                    .modal('setting', 'closable', false)
                    .modal('show')
            },
        },
        components: {
            SpeedTest,
            Partitions,
            Notifications
        },
    }
</script>
<style scoped lang="scss">
    @media only screen and (max-width: 640px) {
        .ui.menu {
            .right.menu {
                flex-wrap: wrap;
            }
        }
    }
    .ui.menu .item:before {
        width: 0;
    }

    .compact.menu {
        div.item:not(:last-child) {
            width: 55px;
            height: 55px;
            padding: .5em;
        }
    }
</style>
<style lang="scss">
#top_menu .compact.menu .menu.transition {
    max-height: 30em;
    overflow-x: hidden;
    overflow-y: auto;
}
@media only screen and (max-width: 390px) {
    #top_menu .compact.menu div.item {
        & .button {
            padding: .5em;
        }
        &:not(:last-child) {
            width: 35px;
            height: 35px;
            margin: .3em;
        }
    }
}
</style>
